<ion-content>
  <div class="quiz-container">
    <button class="close" (click)="onDismiss_click()"><ion-icon name="close-circle"></ion-icon></button>
    <div class="quiz" *ngIf="quizData">
      <div class="question">
        <img [src]="quizData.question.imageUrl" *ngIf="quizData.question.imageUrl">
        <h2>{{ quizData.question.text }}</h2>
      </div>
      <div class="answers">
        <p *ngIf="!isChecked">Zaznacz jedną prawidłową odpowiedź</p>
        <p *ngIf="isChecked && isCorrect" class="answer--ok">Prawidłowa odpowiedź</p>
        <p *ngIf="isChecked && !isCorrect" class="answer--error">Nieprawidłowa odpowiedź</p>
        <div class="answer"
             [class.correct-answer]="answer.id === correctAnswerUid"
             [class.selected]="answer.isSelected"
             [class.is-correct]="answer.isCorrect"
             [class.is-incorrect]="answer.isCorrect !== null && answer.isCorrect !== undefined && !answer.isCorrect"
             *ngFor="let answer of quizData.question.answers"
             (click)="selectAnswer(answer.id)">
          <label class="answer-text">{{ answer.text }}</label>
        </div>
        <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>
        <ion-button *ngIf="!isChecked" [disabled]="!isAnswered || isFinished" (click)="onCheckAnswer_click()">Sprawdź</ion-button>
        <ion-button *ngIf="isChecked" (click)="onClose_click()">Zakończ</ion-button>
      </div>
    </div>
  </div>
</ion-content>
